module.exports = {
      id: "comm-environment-usage",
      viewBox: "0 0 276.484 47.102",
      url: "/" + "sprite-036dd45d0e77a995aefc8cbeaab2becc.svg#comm-environment",
      toString: function () {
        return this.url;
      }
    }